import classNames from "classnames";
import React, { Component } from "react";
import "../../../../styles/main.scss";

interface KuikaH1Props extends React.HTMLAttributes<HTMLHeadingElement> {
  children: React.ReactNode;
}

class KuikaH1 extends Component<KuikaH1Props> {
  render() {
    const { children, className, ...props } = this.props;

    return (
      <h1 className={classNames("kuika-typography-h1", className)} {...props}>
        {children}
      </h1>
    );
  }
}

export default KuikaH1;
